import React from 'react'
import { ConfirmationAction, DialogRenderer } from './confirmation-action'
import { RoleSwitch, Role } from '../../components/roles'
import { Placement } from '../popper'
import { MessageDescriptor } from 'react-intl'
import { IconButtonProps } from '@contrast-security-inc/design-system-buttons'
import { IconSize } from '@contrast-security-inc/design-system-foundations'

export interface ConfirmationRoleActionProps {
  isActionValid: boolean
  role: Role
  requiredRole: Role
  renderDialog: DialogRenderer
  icon: IconButtonProps['Icon']
  hideTooltip?: boolean
  iconTooltipMessage: MessageDescriptor
  disabledTooltipMessage?: MessageDescriptor
  iconTooltipPlacement?: Placement
  iconMetadata?: React.ReactNode
  pendoId?: string
  showDisabled?: boolean
  size?: IconSize
}

export function ConfirmationRoleAction({
  isActionValid,
  role,
  requiredRole,
  renderDialog,
  icon,
  iconTooltipMessage,
  iconTooltipPlacement,
  iconMetadata,
  pendoId,
  hideTooltip,
  disabledTooltipMessage,
  showDisabled,
  ...rest
}: ConfirmationRoleActionProps) {
  return (
    <React.Fragment>
      {isActionValid && (
        <RoleSwitch
          role={role}
          requiredRole={requiredRole}
          renderAllowed={() => {
            return (
              <ConfirmationAction
                {...rest}
                icon={icon}
                hideTooltip={hideTooltip}
                iconTooltipMessage={iconTooltipMessage}
                iconTooltipPlacement={iconTooltipPlacement}
                renderDialog={renderDialog}
                iconMetadata={iconMetadata}
                pendoId={pendoId}
              />
            )
          }}
          renderDenied={
            showDisabled
              ? () => (
                  <ConfirmationAction
                    {...rest}
                    icon={icon}
                    hideTooltip={hideTooltip}
                    iconTooltipMessage={
                      disabledTooltipMessage || iconTooltipMessage
                    }
                    iconTooltipPlacement={iconTooltipPlacement}
                    renderDialog={renderDialog}
                    iconMetadata={iconMetadata}
                    pendoId={pendoId}
                    isDisabled={true}
                  />
                )
              : undefined
          }
        />
      )}
    </React.Fragment>
  )
}
